const LinkAPlan = {
  title: {
    Any:
      "You're currently viewing a lapsed plan.  Do you have a new plan with us?",
    HOL:
      "You're currently viewing a lapsed policy.  Do you have a new policy with us?"
  },
  description: {
    Any:
      "You can link your new membership number to this account to access your documents and claims information.",
    HOL:
      "You can link your new policy number to this account to access your documents and claims information."
  },
  buttonLabel: {
    Any: "link another plan"
  }
};

export default LinkAPlan;
